module.exports = __webpack_public_path__ + "static/assets/da937038f7b0ebc0aa7d22dee4aafad2.gif";